<mat-toolbar mat-dialog-title>{{ title }}</mat-toolbar>

<mat-dialog-content class="upload-dialog-content">
  @if (isCustomMode) {
    <div class="custom-upload">
      <div class="file-row">
        <button (click)="primaryFileInput.click()" color="primary" mat-raised-button type="button" data-test="custom-primary-file-btn">
          <mat-icon>upload_file</mat-icon>
          {{ selectedFile ? selectedFile.name : ('select_file_tr' | translate) }}
        </button>
        <input #primaryFileInput hidden type="file" (change)="onPrimaryFileSelected($event)" data-test="custom-primary-file-input" />
      </div>

      @if (secondaryFileConfig; as secondary) {
        <div class="file-row secondary-file" data-test="custom-secondary-file-row">
          <label>{{ secondary.label }}</label>
          <p class="hint">{{ secondary.hint }}</p>
          <button (click)="secondaryFileInput.click()" mat-stroked-button type="button" data-test="custom-secondary-file-btn">
            {{ selectedSecondaryFile ? selectedSecondaryFile.name : ('select_file_tr' | translate) }}
          </button>
          <input
            #secondaryFileInput
            hidden
            type="file"
            (change)="onSecondaryFileSelected($event)"
            data-test="custom-secondary-file-input"
          />
        </div>
      }

      @if (customBusy) {
        <mat-progress-bar mode="indeterminate" data-test="custom-upload-progress"></mat-progress-bar>
      }
      @if (customError) {
        <mat-error data-test="custom-upload-error">{{ customError }}</mat-error>
      }
    </div>
  } @else {
    <form [formGroup]="form">
      @if (step === 1) {
        <mat-radio-group formControlName="type">
          @for (t of types; track t) {
            <div (click)="type = t.id" class="type">
              <mat-radio-button [value]="t.id">
                {{ t.name }}
              </mat-radio-button>
            </div>
          }
        </mat-radio-group>
      }

      @if (step === 2) {
        <mat-form-field>
          <mat-label>{{ 'document_date_tr' | translate }}</mat-label>
          <input [matDatepicker]="documentDatePicker" formControlName="date" matInput placeholder="MM/DD/YYYY" />
          <mat-datepicker-toggle [for]="documentDatePicker" matIconSuffix></mat-datepicker-toggle>
          <mat-datepicker #documentDatePicker></mat-datepicker>
          <mat-error>{{ 'Required_field_tr' | translate }}</mat-error>
        </mat-form-field>
      }

      @if (step === 2) {
        <mat-form-field>
          <mat-label>{{ 'Title_tr' | translate }}</mat-label>
          <input autotrim formControlName="title" matInput />
          <mat-error>{{ 'Required_field_tr' | translate }}</mat-error>
        </mat-form-field>
      }

      @if (step === 2 && uploadStatus) {
        <div class="upload-status">
          <h4 mat-line>{{ uploadStatus.name }}</h4>
          @if (uploadStatus.error) {
            <div class="upload-error">
              <mat-error>{{ uploadStatus.error }}</mat-error>
              <button type="button" (click)="removeUpload()" color="primary" mat-raised-button>ok</button>
            </div>
          } @else {
            <mat-label>{{ 'uploading_tr' | translate }} ... {{ uploadStatus.progress | number: '1.0-0' }}%</mat-label>
            <mat-progress-bar [value]="uploadStatus.progress" mode="determinate"></mat-progress-bar>
            <button type="button" (click)="removeUpload()" mat-button>{{ 'cancel_tr' | translate }}</button>
          }
        </div>
      }

      @if (step === 2 && uploadResult) {
        <div class="upload-result">
          <h4>{{ uploadResult.fileName }}</h4>
        </div>
      }

      @if (step === 2 && !uploadResult && !uploadStatus && fileInput) {
        <button type="button" (click)="fileInput.click()" color="primary" mat-raised-button class="select-file-btn">
          {{ 'select_file_tr' | translate }}
        </button>
      }
    </form>
  }
</mat-dialog-content>

<dialog-form-actions>
  @if (isCustomMode) {
    <button
      type="button"
      (click)="submitCustomUpload()"
      [disabled]="!selectedFile || customBusy"
      color="primary"
      mat-raised-button
      data-test="custom-upload-submit"
    >
      <mat-icon>save</mat-icon>
      {{ 'Save_tr' | translate }}
    </button>
  } @else {
    @if (step === 1) {
      <button type="button" (click)="startUpload()" [disabled]="form.controls.type.invalid" color="primary" mat-raised-button>
        <mat-icon>forward</mat-icon>
        {{ 'upload_file_tr' | translate }}
      </button>
    }

    @if (step === 2) {
      <button type="button" (click)="save()" [disabled]="form.invalid || !uploadResult" color="primary" mat-raised-button>
        <mat-icon>save</mat-icon>
        {{ 'Save_tr' | translate }}
      </button>
    }
  }

  <button type="button" mat-button mat-dialog-close [disabled]="customBusy">{{ 'cancel_tr' | translate }}</button>
</dialog-form-actions>
